import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  GET_USER,
  FETCH_USER,
  LOG_OUT,
  FETCH_COMPANY,
  UPDATE_PROFILE_AUTH_USER
} from 'constants/ActionTypes';

export const fetchUser = () => {
  return {
    type: FETCH_USER
  };
};
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: {
      companyCode: user.companyCode,
      username: user.username,
      password: user.password
    }
  };
};
export const userSignOut = () => {
  return {
    type: SIGNOUT_USER
  };
};
export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};
export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};
export const getUser = () => {
  return {
    type: GET_USER,
    payload: ''
  }; 
};
export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};
export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
export const logOutUser = () => {
  return {
    type: LOG_OUT,
  };
};
export const fetchCompany = () => {
  return {
    type: FETCH_COMPANY,
  };
};
export const updateProfileAuthUser = (data) => {
  return {
    type: UPDATE_PROFILE_AUTH_USER,
    payload: data
  };
};



// WEBPACK FOOTER //
// ./actions/Auth.js